module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_FA.38b6f474.txt";